import {CustomNodeWidget, CustomNodeWidgetProps} from '@/components/Canvas/customNodes/CustomNodeWidget'
import {SendEmailNodeModel} from '@/components/Canvas/customNodes/SendEmail/SendEmailNodeModel'
import {useWidgetInfo} from '@/components/Canvas/hooks/useWidgetInfo'
import {Icon} from 'pepsico-ds'

export interface SendEmailNodeWidgetProps extends CustomNodeWidgetProps {
  node: SendEmailNodeModel
}

export const SendEmailNodeWidget = ({engine, node, ...props}: SendEmailNodeWidgetProps) => {
  const {formatMessage, haveWarnings, isSelected, portBottom, portTop} = useWidgetInfo(node)

  return (
    <CustomNodeWidget
      {...props}
      engine={engine}
      node={node}
      portTop={portTop}
      portBottom={portBottom}
      isSelected={isSelected}
      haveWarnings={haveWarnings}
      classNameWidgetWrapper="node-widget type-send-email"
    >
      <div className={`flex items-center justify-center ${haveWarnings ? 'gap-2' : 'gap-3'}`}>
        <div className="node-icon" data-testid="send-email-icon">
          <Icon icon="sms" size="small" className="$color-icon" />
        </div>
        <div className="node-content">
          <p className="node-name">{formatMessage({id: 'JOURNEY_BUILDER.SEND_EMAIL_WIDGET_LABEL'})}</p>
        </div>
      </div>
    </CustomNodeWidget>
  )
}
